module.exports = __webpack_public_path__ + "img/plex.f2656d43.svg";